import type { InferOutput } from "valibot";

export const lillopointsItemSchema = v.object({
  timestamp: v.number(),
  description: v.string(),
  order_id: v.number(),
  points: v.number(),
  total: v.number(),
});
export type LillopointsItem = InferOutput<typeof lillopointsItemSchema>;

export const myLillopointsSchema = v.object({
  items: v.array(lillopointsItemSchema),
});
export type MyLillopoints = InferOutput<typeof myLillopointsSchema>;
